module.exports = "<div kd-alert__icon ng-bind-html=\"$ctrl.icon\"></div>\r\n<div kd-alert__content ng-transclude></div>\r\n<button kd-alert__button\r\n    ng-if=\"$ctrl.dismisable\"\r\n    type=\"button\"\r\n    ng-click=\"$ctrl.close()\">\r\n  <i class=\"fa fa-times\"></i>\r\n</button>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/kendu/ui/components/kd-alert/template.html
// module id = 288
// module chunks = 0